// @ts-ignore
// @ts-ignore

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IModif } from '../models/IModif';
import { NavigationConfirmService } from './navigation-confirm.service';

@Injectable({ providedIn: 'root' })
export class ContextService {
  private mineIdSubject = new BehaviorSubject<number | null>(null);
  private customeridSubject = new BehaviorSubject<number | null>(null);
  siteId$ = this.mineIdSubject.asObservable();
  customerId$ = this.customeridSubject.asObservable();
  private pendingRegistrations: IModif[] = [];

  constructor(private navigationConfirm: NavigationConfirmService) {}

  setMineId(id: number) {
    this.mineIdSubject.next(id);
  }

  setCustomerId(id: number) {
    this.customeridSubject.next(id);
  }

  /**
   * Your component pending status will be taken in account when changing site
   * @param registered
   */
  register(registered: IModif) {
    this.pendingRegistrations.push(registered);
  }

  /**
   *
   * @param unregistered
   */
  unRegister(unregistered: IModif) {
    if (this.pendingRegistrations) {
      const index = this.pendingRegistrations.indexOf(unregistered);
      if (index > -1) {
        this.pendingRegistrations.splice(index, 1);
      }
    }
  }

  /**
   * Tell if there is any pending modification in the registered tellers
   * @private
   */
  public isModificationPending(): boolean {
    if (this.pendingRegistrations) {
      for (let registered of this.pendingRegistrations) {
        if (registered.getModifStatus()) {
          return true;
        }
      }
    }
    return false;
  }
}
